import { all, call, fork, takeEvery, put } from 'redux-saga/effects';
import Immutable from 'immutable';

// action creators
import { doneIndicator, success } from 'store/actions/httpActions';

// api
import client from 'sources/api';

// constants
import {
  GROUP_VALUE_DELETE_REQUEST,
  GROUP_VALUE_DELETE,
} from 'store/constants/groupValueTypes';

// helpers
import httpSaga from 'store/sagas/httpSaga';

// schemas
import { groupValueSchema } from 'store/schemas/groupValueSchema';

const WATCH_TYPE = GROUP_VALUE_DELETE_REQUEST;
const TYPE = GROUP_VALUE_DELETE;

export function* deleteGroupValue(action: any) {
  const { label, groupId } = action.payload;

  const META_ID = `delete-${label}`;

  const endpoint = `/group_values?group_id=${groupId}`;

  // @ts-expect-error ts-migrate(2569) FIXME: Type 'Generator<any, any, unknown>' is not an arra... Remove this comment to see the full error message
  yield* httpSaga(
    TYPE,
    call(client.delete, endpoint, {
      // delete needs a data object in order to use a request body
      data: {
        label,
      },
    }),
    {
      dispatchSuccess: false,
      schema: groupValueSchema,
      metaId: META_ID,
    }
  );

  // Send the response data to the store for this type to be caught by a reducer
  yield put(
    success(
      TYPE,
      Immutable.fromJS({
        label,
      }),
      META_ID
    )
  );

  yield put(doneIndicator(TYPE));
}

export function* watch() {
  yield takeEvery(WATCH_TYPE, deleteGroupValue);
}

export default function* root() {
  yield all([fork(watch)]);
}
